<script setup>
import JobListItem from 'components/JobListItem.vue';

const $emit = defineEmits(['load:click', 'job:click']);

const $props = defineProps({
    jobs: {
        type: Array,
        default: []
    },
    isLoaded: {
        type: Boolean,
        default: false
    },
    isLoadMoreEnabled: {
        type: Boolean,
        default: false
    },
    split: {
        type: Boolean,
        default: false
    },
    minimal: {
        type: Boolean,
        default: false
    },
    dense: {
        type: Boolean,
        default: false
    },
    activeJobScopeId: {
        type: Number,
        default: null
    },
    hideShortlistBtn: {
        type: Boolean,
        default: false
    },
    openSeparateTab: {
        type: Boolean,
        default: false
    }
});
</script>

<template>
    <div class="job-list">
        <div v-if="isLoaded && jobs.length > 0">
            <div class="row q-col-gutter-md">
                <div v-for="j in jobs" :key="j.id" :class="$props.split ? 'col-12 col-md-6' : 'col-12'">
                    <JobListItem
                        @click="$emit('job:click')"
                        :job="j"
                        :active="typeof activeJobScopeId === 'number' && activeJobScopeId === +j.scopes?.[0]?.id"
                        :open-separate-tab="openSeparateTab"
                        :hide-shortlist-btn="hideShortlistBtn"
                        :minimal
                        :dense
                    />
                </div>
            </div>
            <div v-if="isLoadMoreEnabled" class="text-center q-my-xl">
                <q-btn @click="$emit('load:click')" label="Load more jobs" aria-label="Load more jobs" color="primary"/>
            </div>
        </div>
        <div v-else-if="isLoaded" class="text-center no-jobs-found">
            <slot name="no-jobs">
                <q-icon name="sym_r_search_off" size="48px" class="q-mt-xl q-mb-lg"/>
                <h6 class="q-mt-xs">No matching jobs found</h6>
                <p>Try broadening your search by adjusting the job title, location, or the advanced filters.</p>
                <p>Please note, we're a new platform and are actively working to bring more job opportunities to you every day.</p>
                <p>Thank you for your patience and support as we grow!</p>
            </slot>
        </div>
    </div>
</template>

<style scoped lang="scss">
.job-list {
    width: 100%;
}

.no-jobs-found {
    .centered-list {
        padding: 0;
        list-style: none;
        text-align: center;
    }

    .centered-list li {
        display: block;
        position: relative;
    }

    .centered-list li::before,
    .centered-list li::after {
        color: $grey-5;
        content: '—';
        margin: 0 10px;
    }
}
</style>
